import { render, staticRenderFns } from "./AxStar.vue?vue&type=template&id=5784df2b&scoped=true&"
import script from "./AxStar.vue?vue&type=script&lang=ts&"
export * from "./AxStar.vue?vue&type=script&lang=ts&"
import style0 from "./AxStar.vue?vue&type=style&index=0&id=5784df2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5784df2b",
  null
  
)

export default component.exports